// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"dc6b5553","551":"3609c92d","851":"0b449e10"}[chunkId] + ".chunk.js";
};